import { Component, Vue } from "vue-property-decorator";

@Component
export default class PlusIcon extends Vue {
  render() {
    return (
      <svg
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0003 6.79166L20.0003 33.4583M33.3337 20.125L6.66699 20.125"
          stroke="#0C0A09"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
}
